import { Card, CardContent } from '@/components/ui/card';
import { BarChart3, Plug, FileText, Target, Upload, Package } from 'lucide-react';

const features = [
  {
    icon: BarChart3,
    title: 'Dashboard Inteligente',
    description: 'MRR, ARR, Churn, LTV e CAC em tempo real com atualizações automáticas',
  },
  {
    icon: Plug,
    title: '10+ Integrações',
    description: 'Conecte com Hotmart, Stripe, Mercado Pago, Kiwify, Eduzz e mais',
  },
  {
    icon: FileText,
    title: 'Relatórios Automáticos',
    description: 'Exporte relatórios em PDF e Excel com apenas um clique',
  },
  {
    icon: Target,
    title: 'Metas Inteligentes',
    description: 'Defina e acompanhe objetivos por produto e período',
  },
  {
    icon: Upload,
    title: 'Importação em Massa',
    description: 'Importe seus dados históricos via planilhas Excel ou CSV',
  },
  {
    icon: Package,
    title: 'Multi-Produtos',
    description: 'Gerencie múltiplos produtos e serviços em uma única conta',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-20 md:py-32 bg-muted/50">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mx-auto max-w-2xl text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            Tudo que você precisa em um lugar
          </h2>
          <p className="text-xl text-muted-foreground">
            Ferramentas poderosas para gestão completa das suas métricas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} className="border-2 hover:border-primary/50 transition-all hover:shadow-lg">
                <CardContent className="p-6 space-y-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
